import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BlurModal from '../blur-modal';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';

class comClass extends PureComponent {

  constructor(props) {
    super(props);

    this.closeAlert = this.closeAlert.bind(this);

  }

  componentDidUpdate(){
    if(document.querySelector('.alertFocus')){      // for accessibility portfolio selection popoup focus
      document.querySelector('.alertFocus').focus();
    }
  }

  closeAlert(){
    this.props.closeAlertBox();
  }

  render() {
    const { i18n: {messages}} = this.props;
    return (

      <BlurModal
        visible={this.props.screen.alert.show}
        doneVisible={false}
        title={messages['app.auth.logout.header']}
        onDone={()=>this.closeAlert()}
        className="model-window-login"
        >

        <div className="row">
          <div className="small-12 pad-left-10 pad-right-20">
            <div className="alertbox">
              <div tabIndex={0} className="message alertFocus model-detail-text"> {this.props.screen.alert.message} </div>


              <div className="margin-top-20">
                <div className="button_container">
                  <Button size="large" testID="btn_alertModal_alert_test" id="alertWindow" onClick={()=>this.closeAlert()}> {messages['app.rmcallback.okMsg']}</Button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </BlurModal>

    );
  }
}


export default createContainer({
  $queries: {
    closeAlertBox : { $call: 'screen.alert.close' },
    screen:{
      alert:{
        show: true,
        message: true
      }
    },
    i18n: {
      messages: true,
    }
  },
})(comClass);



